<template>
  <div class="col-12">
    <slot :items="items"
          :loading="loading"
          :confirm-delete="confirmDelete"
          :query="query"
          :update-query="updateQuery"

          :order-by="orderBy"></slot>
    <div class="text-center">
      <div class="custom-pagination" v-if="shouldShowPagination && !loading">
        <div class="row center mt-2 mt-lg-0 mb-2">

        </div>
        <div class="row">
          <div class="col-6 col-sm-2">
            <button class="btn btn-outline-secondary btn-block"
                    :disabled="!enabledPrevPageButton"
                    @click="fetchPrevPage">
              Anterior
            </button>
          </div>
          <div class="col-sm-8">
            <button class="btn btn-light"
                    v-for="button in paginationButtons"
                    :ref="'paginationButton' + button.page"
                    :class="{'active': button.active, 'disabled': button.disabled}"
                    @click="changePage(button.page)">
              {{button.text}}
            </button>
          </div>
          <div class="col-6 col-sm-2">
            <button class="btn btn-outline-secondary btn-block"
                    :disabled="!enabledNextPageButton"
                    @click="fetchNextPage">
              Próximo
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

  import bootbox from '../../bootbox.min';

  export default {

    template: '#data-list',
    props: {
      dataSource: {
        type: String,
      },

      identifier: {
        default: '',
      },

      urlCreate: {
        type: String,
        default() {
          return null;
        },
      },

      labelCreate: {
        type: String,
        default() {
          return 'Cadastrar novo';
        },
      },

      deleteMessage: {
        type: String,
        default() {
          return 'Tem certeza que deseja apagar este registro?';
        },
      },

      resendMessage: {
        type: String,
        default() {
          return 'Tem certeza que deseja reenviar este e-mail?'
        },
      },

      undeleteMessage: {
        type: String,
        default() {
          return 'Tem certeza que deseja restaurar este usuário?'
        },
      },

      deleteTitle: {
        type: String,
        default() {
          return 'Excluir registro';
        },
      },

      resendTitle: {
        type: String,
        default() {
          return 'Reenviar e-mail';
        },
      },

      undeleteTitle: {
        type: String,
        default() {
          return 'Restaurar';
        },
      },
    },

    watch: {
      query: _.debounce(function (text) {
        this.currentPage = 1;
        this.fetchData();
      }, 350),

      'filters.status': function () {
        this.setFilter('status', this.filters.status);
        this.fetchData();
      },
    },

    computed: {
      queryFilters() {
        let query_filters = '';
        for (var filterName in this.filters) {
          if (this.filters.hasOwnProperty(filterName)) {
            query_filters += '&' + filterName + '=' + this.filters[filterName];
          }
        }
        return query_filters;
      },

      fetch_url() {
        let query_params = '';
        query_params = '?query=' + this.query;
        query_params += '&field=' + this.field;
        query_params += '&order=' + this.order;

        if (this.currentPage != 1) {
          query_params += '&page=' + this.currentPage;
        }

        query_params += this.queryFilters;

        const url = this.dataSource + query_params;
        return encodeURI(url);
      },

      no_results() {
        return typeof this.items == 'undefined' || this.items.length == 0;
      },

      enabledNextPageButton() {
        return this.currentPage < this.totalPages;
      },

      enabledPrevPageButton() {
        return this.currentPage > 1;
      },

      shouldShowPagination() {
        return this.totalPages > 1;
      },

      isNotLoading() {
        return !this.loading;
      },
    },

    data: function () {
      return {
        items: [],
        loading: true,

        query: '',
        field: '',
        order: 'desc',

        totalPages: 1,
        currentPage: 1,
        itemsPerPage: 15,
        paginationButtons: [],
        departmentId: null,
        departmentName: null,

        count: {
          actives: 0,
          inactives: 0,
        },

        filters: {}
      }
    },

    mounted() {
      this.listenFilters();
      this.listenLoadingEvents();
      this.fetchData();
      this.$root.$on('reload-data', () => this.fetchData());
    },

    methods: {
      updateQuery(value) {
        this.query = value;
      },

      orderBy(field, event) {
        this.field = field;
        this.toggleOrder();
        this.setOrderArrowIn(event.target);
        this.fetchData();
      },

      toggleOrder() {
        this.order = (this.order == 'asc') ? 'desc' : 'asc';
        return this.order;
      },

      setOrderArrowIn(element) {
        let defaultClass = '.order-arrow';
        let classToRemove = $(element).attr('class');

        let toQuery = classToRemove ? `.${classToRemove} > .order-arrow` : defaultClass;

        let arrows = Array.from(document.querySelectorAll(toQuery));

        arrows.forEach((node) => {
          node.parentNode.removeChild(node);
        });

        element.appendChild(this.getArrow());
      },

      getArrow() {
        let arrow_classes = '';
        if (this.order == 'asc') {
          arrow_classes = 'fa fa-angle-up order-arrow'
        } else {
          arrow_classes = 'fa fa-angle-down order-arrow'
        }

        const arrow = document.createElement('i');
        arrow.className = arrow_classes;

        return arrow;
      },

      getRef(ref) {
        return this.$refs[ref];
      },

      setPagination(fetched_data) {
        if (typeof fetched_data !== 'undefined') {
          if (fetched_data.meta) {
            this.totalPages = fetched_data.meta.last_page;
            this.currentPage = fetched_data.meta.current_page;
            this.itemsPerPage = fetched_data.meta.per_page;
          } else {
            this.totalPages = fetched_data.last_page;
            this.currentPage = fetched_data.current_page;
            this.itemsPerPage = fetched_data.per_page;
          }
        }
      },

      fetchData() {
        this.$root.$emit('start-loading');
        const localQuery = this.query;
        axios.get(this.fetch_url).then((response) => {
          if (localQuery === this.query) {
            this.items = response.data.data;
            this.setPagination(response.data);
            this.definePaginationButtons();
            this.$root.$emit('stop-loading');
            this.$nextTick().then(function () {
              let div = $('[data-toggle="popover"]')
              if (div)
                div.popover();
            });
          }
        });
      },

      fetchPrevPage() {
        if (this.enabledPrevPageButton) {
          this.currentPage = this.currentPage - 1;
          this.fetchData();
        }
      },

      fetchNextPage() {
        if (this.enabledNextPageButton) {
          this.currentPage = this.currentPage + 1;
          this.fetchData();
        }
      },

      definePaginationButtons() {
        const totalPages = this.totalPages;
        let startPage = this.currentPage - 3;
        let endPage = this.currentPage + 3;
        let buttons = [];

        if (startPage <= 0) {
          endPage -= (startPage - 1);
          startPage = 1;
        }

        if (endPage > totalPages)
          endPage = totalPages;

        if (startPage > 1) {
          buttons.push({disabled: false, page: 1, text: '1'});
          buttons.push({disabled: true, page: 0, text: '...'});
        }

        for (let i = startPage; i <= endPage; i++) {
          const active = (i == this.currentPage);
          buttons.push({disabled: false, page: i, text: i, active: active});
        }

        if (endPage < totalPages) {
          buttons.push({disabled: true, page: 0, text: '...'});
          buttons.push({disabled: false, page: totalPages, text: totalPages});
        }

        this.paginationButtons = buttons;
      },

      changePage(page) {
        this.currentPage = page;
        this.fetchData();
      },

      handleDelete(link) {
        const token = $('meta[name="csrf-token"]').attr('content');
        const vm = this;
        $.ajax({
          url: link,
          type: 'DELETE',
          data: {_token: token},
          success: function (result) {
            result = JSON.parse(result);
            vm.$root.throwFlashMessage('success', result.message);
            vm.fetchData();
          }
        });
      },

      handleResendEmail(link) {
        axios.get(link).then((response) => {
          const status = response.data;
          if (status.type) {
            this.$snotify[status.type](status.message);
            this.fetchData();
          } else {
            this.$snotify.error('Action undefined');
          }
        });
      },

      activate(link) {
        axios.post(link).then((response) => {
          const status = response.data;
          if (status.type) {
            this.$snotify[status.type](status.message);
            $('.tooltip').remove();
            this.fetchData();
          } else {
            this.$snotify.error('Action undefined');
          }
        });
      },

      deactivate(link) {
        axios.post(link).then((response) => {
          const status = response.data;
          if (status.type) {
            this.$snotify[status.type](status.message);
            $('.tooltip').remove();
            this.fetchData();
          } else {
            this.$snotify.error('Action undefined');
          }
        });
      },

      confirmDelete(link, message = undefined) {
        if (message == undefined) {
          message = this.deleteMessage;
        }
        bootbox.confirm(message, result => {
          if (result) {
            this.handleDelete(link)
          }
        });
      },

      confirmResendEmail(link, message = undefined) {
        if (message == undefined) {
          message = this.resendMessage;
        }

        this.$snotify.confirm(message, this.resendTitle, {
          timeout: 5000,
          showProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          buttons: [
            {text: 'Sim', action: () => this.handleResendEmail(link), bold: false},
            {text: 'Não'},
          ]
        });
      },

      confirmActivateDeactivate(link, action, message = undefined) {
        let title = 'Ativar';
        if (message == undefined) {
          if (action == 'activate') {
            message = 'Tem certeza que deseja ativar essa categoria?';
          } else {
            title = 'Desativar';
            message = 'Tem certeza que deseja desativar esta categoria?';
          }
        }
        bootbox.confirm(message, result => {
          if (result) {
            this.activate(link)
          }
        });
      },

      callRef(ref, func, data) {
        this.$refs[ref][func](data);
      },

      listenFilters() {
        this.$on('setFilter', (payload) => {
          this.setFilter(payload.urlKey, payload.value);
          this.fetchData();
        });
      },

      setFilter(name, value) {
        if (value) {
          this.$set(this.filters, name, value)
        } else {
          delete this.filters[name];
          this.filters = _.assign({}, this.filters);
        }
      },

      listenLoadingEvents() {
        this.$root.$on('start-loading', () => {
          this.loading = true;
        });

        this.$root.$on('stop-loading', () => {
          this.loading = false;
        });
      },
    },
  }
</script>

<style scoped>
  .active {
    font-weight: 700;
    background-color: #ecebeb;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/data-component/DataListComponent.vue